import React, { useEffect, useRef, useState } from "react";
import FormCreator from "../../components/Forms/FormCreator";
import { viewChangeKeyPositionFormData } from "./data/ViewChangeKeyPositionForm.data";
import MolGrid from "../../components/Grid/MolGrid";
import { ViewChangeKeyPositionListConfig } from "./component/ViewChangeKeyPositionListConfig";
import Buttons from "../../components/ui/button/Buttons";
import { useGetAllKeyPositionApprovalRequestListMutation, useLazyGetSignUpDropDownsForCorporateMembersQuery } from "../../app/services/common/commonApi";
import { setAllDropDownField } from "./data/Utils/setFieldParameter";
import { encryptAESID } from "../../utils/Encryption";
import { saveData } from "../../utils/LocalStorage/LocalStorageManager";
import { useNavigate } from "react-router-dom";

const ViewChangeKeyPosition = () => {
  const viewChangeKeyPositionRef = useRef();
  const molGridRef = useRef();
  const [dataSource, setDataSource] = useState();
  const [totalRecord, setTotalRecord] = useState()
  const navigate = useNavigate();
  const [viewChangeKeyPositionForm, setViewChangeKeyPositionForm] = useState(viewChangeKeyPositionFormData);
  const [paginationRequest, setPaginationRequest] = useState({
    pageNo: 1,
    pageSize: 20,
    searchText: "",
    filterByStatus: "",
    dateFrom: "",
    dateTo: "",
    isCertificationCordinator: false,
  });
  const [signUpDropDownsForCorporateMembers, { data: corporateMemberDropDownsData, isLoading: corporateDropDownsLoading, isFetching: signUpDropDownsFetching }] = useLazyGetSignUpDropDownsForCorporateMembersQuery();
  const [getAllKeyPositionApprovalRequestList, { data: getAllKeyPositionList, isSuccess, isLoading, }] = useGetAllKeyPositionApprovalRequestListMutation();

  useEffect(() => {
    signUpDropDownsForCorporateMembers();
    getAllKeyPositionApprovalRequestList(paginationRequest);
  }, [])

  useEffect(() => {
    if (!corporateDropDownsLoading && corporateMemberDropDownsData) {
      setAllDropDownField(corporateMemberDropDownsData);
    }
  }, [corporateDropDownsLoading, corporateMemberDropDownsData]);

  useEffect(() => {
    if (!isLoading && isSuccess && getAllKeyPositionList) {
      setPaginationRequest(prev => ({ ...prev, totalCount: getAllKeyPositionList.totalCount }));
      setDataSource(getAllKeyPositionList?.itemList);
      setTotalRecord(getAllKeyPositionList?.totalCount)
    }
  }, [isLoading, isSuccess, getAllKeyPositionList]);

  const handleSearch = () => {
    if (!viewChangeKeyPositionRef.current) {
      return;
    }
    const taskListFormData = viewChangeKeyPositionRef?.current?.getFormData();
    const updatedPaginationRequest = {
      pageNo: 1,
      pageSize: 20,
      endPage: 100,
      searchText: taskListFormData?.companyName || "",
      FilterByStatus: taskListFormData?.status?.label || taskListFormData?.status,
      dateFrom: taskListFormData?.fromDate || null,
      dateTo: taskListFormData?.toDate || null,
      isCertificationCordinator: false,
    };
    setPaginationRequest(updatedPaginationRequest);
    getAllKeyPositionApprovalRequestList(updatedPaginationRequest);
  };

  const handleProcessClick = (data) => {    navigate(`/keyPositionRequest/${encryptAESID(data?.keyChangeRequestId)}/${encryptAESID(data?.upgradeChangeRequestId)}`);
  }

  const actionHandler = {
    VIEW: handleProcessClick,
  };

  const handlePageChange = ({ pageNumber, pageSize }) => {
    const updatedPaginationRequest = { ...paginationRequest, pageNo: pageNumber, pageSize: pageSize };
    setPaginationRequest(updatedPaginationRequest);
    getAllKeyPositionApprovalRequestList(updatedPaginationRequest);
  };

  const handleClearClick = () => {
    const updatedFormData = { ...viewChangeKeyPositionForm };
    updatedFormData.initialState = {
      companyName: null,
      fromDate: null,
      toDate: null,
      status: null,
    };

    const request = {
      ...paginationRequest,
      pageNo: 1,
      searchText: "",
      filterByStatus: "",
      dateFrom: "",
      dateTo: "",
    };

    setPaginationRequest((prev) => ({ ...prev, ...request }));
    getAllKeyPositionApprovalRequestList(request);
    setViewChangeKeyPositionForm(updatedFormData);
  };


  return (
    <div className="view-change-key-position">
      <div className="filter-section row">
        <div className="row col-12 col-md-12 col-lg-8 col-xl-8 ">
          {corporateMemberDropDownsData &&
            <FormCreator
              ref={viewChangeKeyPositionRef}
              {...viewChangeKeyPositionForm}
            />
          }
        </div>
        <div className="col-4 right-side-btn mt-4">
          <Buttons
            buttonText="Search"
            buttonTypeClassName="success-btn"
            onClick={handleSearch}
          />
          <Buttons
            buttonText="Clear"
            buttonTypeClassName="btn btn-secondary"
            onClick={handleClearClick}
          />
        </div>
      </div>

      <div className="result-section">
        <div>
          <h4>{totalRecord} Records</h4>
        </div>
        <MolGrid
          ref={molGridRef}
          configuration={ViewChangeKeyPositionListConfig}
          allowPagination={true}
          dataSource={dataSource}
          isLoading={isLoading}
          pagination={paginationRequest}
          onPageChange={handlePageChange}
          onActionChange={actionHandler}
        />
      </div>
    </div>
  );
};

export default ViewChangeKeyPosition;
